import { Link } from '@inertiajs/react';
import { Wordmark } from '@/components/Wordmark';
import { navigation } from '@/data/navigation';

type SiteFooterProps = {
  /**
   * Whether the fixed-bottom `StickyMobileCta` is showing above this footer
   * on mobile (i.e. every public page except Contact). When true, the footer
   * reserves extra bottom padding (matching the mockup's `padding-bottom:120px`)
   * so the CTA bar never overlaps the wordmark/nav/meta line at the bottom of
   * the scroll. When false (Contact), the footer keeps its normal padding
   * instead of leaving dead space with nothing to protect.
   */
  reserveForStickyCta?: boolean;
};

/** Site footer: wordmark + link list + meta line, matching the mockup's `footer`/`.foot-grid`/`.flinks`/`.fmeta`. */
export const SiteFooter = ({ reserveForStickyCta = true }: SiteFooterProps) => (
  <footer
    className={`border-line border-t py-11 min-[960px]:py-[52px] min-[960px]:pb-[60px] ${
      reserveForStickyCta ? 'pb-[120px]' : ''
    }`}
  >
    <div className="mx-auto max-w-[1120px] px-5 md:px-10">
      <div className="flex flex-col gap-6.5 md:flex-row md:items-start md:justify-between">
        <Wordmark size="lg" />

        <nav className="text-ink-soft flex flex-wrap gap-x-6 gap-y-4 text-sm">
          {navigation.map((item) => (
            <Link key={item.path} href={item.path}>
              {item.name}
            </Link>
          ))}
        </nav>
      </div>

      <div className="mt-5.5">
        <p className="text-ink-soft text-xs tracking-[.02em]">Home & commercial cleaning</p>
      </div>
    </div>
  </footer>
);
